module.exports = {
  MotionScene: {
    PluginName: "Motion Sahne",
  },
};
